module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/banner/th-8ec76a86a2c82105015ea67b4921fa7e.jpg";